module.exports = __webpack_public_path__ + "static/media/double.857de553.svg";